import React from 'react';
export function TrustBar() {
  return <div className="w-full border-y border-white/5 bg-white/[0.02] py-6 md:py-8" data-id="element-330">
      <div className="container mx-auto px-4" data-id="element-331">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-332">
          <p className="text-sm font-medium text-gray-500 uppercase tracking-widest hidden md:block" data-id="element-333">
            Compatible con:
          </p>

          <div className="flex items-center gap-2" data-id="element-334">
            <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xs" data-id="element-335">
              f
            </div>
            <span className="font-bold text-lg text-gray-300" data-id="element-336">Meta Ads</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-337">
            <div className="w-6 h-6 bg-black border border-white/20 rounded-full flex items-center justify-center text-white font-bold text-xs" data-id="element-338">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3" data-id="element-339">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-340" />
              </svg>
            </div>
            <span className="font-bold text-lg text-gray-300" data-id="element-341">TikTok Ads</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-342">
            <div className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center text-white font-bold text-[8px]" data-id="element-343">
              ▶
            </div>
            <span className="font-bold text-lg text-gray-300" data-id="element-344">YouTube Ads</span>
          </div>

          <div className="h-8 w-px bg-white/10 hidden md:block" data-id="element-345" />

          <div className="text-sm font-medium text-purple-400 bg-purple-500/10 px-3 py-1 rounded-full border border-purple-500/20" data-id="element-346">
            +50,000 creativos generados
          </div>
        </div>
      </div>
    </div>;
}